/**
 * API Error class for better error handling
 */
export class ApiError extends Error {
  constructor(message, status, data) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.data = data
  }
}

/**
 * Fetch wrapper that automatically includes Authorization header
 * and handles 401 responses by clearing auth and redirecting to login
 */
export async function fetchWithAuth(url, options = {}) {
  // Get token from localStorage
  const token = localStorage.getItem('auth_token')

  if (!token) {
    // If no token, redirect to login
    window.location.href = '/login'
    throw new ApiError('No authentication token', 401, null)
  }

  // Add Authorization header
  const headers = {
    ...options.headers,
    'Authorization': `Bearer ${token}`
  }

  // Make request
  const response = await fetch(url, {
    ...options,
    headers
  })

  // Handle 401 Unauthorized - token invalid or expired
  if (response.status === 401) {
    // Clear auth and redirect to login
    localStorage.removeItem('auth_token')
    localStorage.removeItem('auth_user')
    window.location.href = '/login'
    throw new ApiError('Unauthorized - please log in again', 401, null)
  }

  // Handle other errors
  if (!response.ok) {
    let errorData = null
    try {
      errorData = await response.json()
    } catch {}

    const message = errorData?.error || `HTTP ${response.status}`
    throw new ApiError(message, response.status, errorData)
  }

  return response
}

/**
 * Helper for JSON requests with auth
 */
export async function fetchJsonWithAuth(url, options = {}) {
  const response = await fetchWithAuth(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

  return response.json()
}
